export default __webpack_public_path__ + "static/media/Snd_TryL.6547b567.mp3";